<div class="counts" *ngIf="leadCounts">
  <mat-expansion-panel class="count-panel" [hideToggle]="true">
    <mat-expansion-panel-header class="header">
      <mat-panel-title class="panel-title"
        >Leads <span>{{ leadCounts.total }}</span></mat-panel-title
      >
    </mat-expansion-panel-header>
    <div class="panel-body">
      <div
        class="panel-item"
        [routerLink]="['counts/list', 'leadCounts', 'pending']"
      >
        <p class="count">Pending leads to schedule</p>
        <span>{{ leadCounts.pendingLeadsToSchedule }}</span>
      </div>
      <div
        class="panel-item"
        [routerLink]="['counts/list', 'leadCounts', 'resets']"
      >
        <p class="count">Resets to schedule</p>
        <span>{{ leadCounts.resetsToSchedule }}</span>
      </div>
      <div
        class="panel-item"
        [routerLink]="['counts/list', 'leadCounts', 'revisits']"
      >
        <p class="count">Revisits to schedule</p>
        <span>{{ leadCounts.revisitsToSchedule }}</span>
      </div>
      <div
        class="panel-item"
        [routerLink]="['counts/list', 'leadCounts', 'reschedule']"
      >
        <p class="count">Leads to Reschedule</p>
        <span>{{ leadCounts.rescheduleLeads }}</span>
      </div>
      <div
        class="panel-item"
        [routerLink]="['counts/list', 'leadCounts', 'pendingDead']"
        *ngIf="
          getUserRole() === 'Call Center Admin' ||
          getUserRole() === 'Admin' ||
          getUserRole() === 'Super Admin'
        "
      >
        <p class="count">Pending Dead Leads</p>
        <span>{{ leadCounts.pendingDeadLeads }}</span>
      </div>
    </div>
  </mat-expansion-panel>
</div>
